// Global entry point
// Registers shared custom elements and initialises site-wide behaviours.
import CarouselSwiper from 'TsComponents/carousel-swiper';
import migrateSection, { appendSection } from 'TsComponents/migrate-section';
import { initUIComponents } from 'TsComponents/ui-components';
import allBrands from '../sections/all-brands';
import glossary from './glossary';
import customBlog from './custom-blog-list';
import searchInitialContent from './search';

document.addEventListener('DOMContentLoaded', () => {
	customElements.define('carousel-swiper', CarouselSwiper);
	allBrands();
	appendSection();
	migrateSection();
	initUIComponents();
	glossary();
	customBlog();
	searchInitialContent();
});
